import { render } from "./UIOverlay.vue?vue&type=template&id=03c4e15c"
import script from "./UIOverlay.vue?vue&type=script&lang=js"
export * from "./UIOverlay.vue?vue&type=script&lang=js"

import "./UIOverlay.vue?vue&type=style&index=0&id=03c4e15c&lang=scss"
script.render = render

export default script